<template>
  <!-- 主路由内容 -->
  <div v-if="isMainRoute" class="company-main-layout">
    <!-- 使用Banner组件 -->
    <Banner :banner-list="bannerList" :accordion-items="accordionItems" />
  </div>
  
  <!-- 子路由内容 -->
  <div v-else class="layout-container">
    <div class="sidebar">
      <el-menu
        :router="true"
        :default-active="normalizedRoutePath"
      >
        <el-menu-item index="/products/tape">
          {{ t('pages.products.tape.title') }}
        </el-menu-item>
        <el-menu-item index="/products/performance">
          {{ t('pages.products.performance.title') }}
        </el-menu-item>
        <el-menu-item index="/products/advantages">
          {{ t('pages.products.advantages.title') }}
        </el-menu-item>
        <el-menu-item index="/products/service">
          {{ t('pages.products.service.title') }}
        </el-menu-item>
      </el-menu>
    </div>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { computed, ref } from 'vue';
import Banner from '@/components/Home/Banner.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const normalizedRoutePath = computed(() => {
  return route.path.replace(/^\/(zh|en)(?=\/|$)/i, '') || '/'
});

// 判断是否是主路由
const isMainRoute = computed(() => {
  return normalizedRoutePath.value === '/products' || normalizedRoutePath.value === '/products/';
});

// 导航到子路由
const navigateTo = (path: string) => {
  router.push(path);
};

// 配置Banner组件的banner列表
const bannerList = ref([
  {
    image: '/images/homebanner/Banner01.jpg',
    title: '产品与技术服务',
    titleAnimation: 'fade-in-down',
    descAnimation: 'fade-in-up'
  },
 
]);

// 配置AccordionSection组件的内容项
const accordionItems = ref([
  {
    title: 'pages.products.tape.title',
    content: '',
    image: '/images/AccordionSection.jpg',
    link: '/products/tape'
  },
  {
    title: 'pages.products.performance.title',
    content: '',
    image: '/images/AccordionSection.jpg',
    link: '/products/performance'
  },
  {
    title: 'pages.products.advantages.title',
    content: '',
    image: '/images/AccordionSection.jpg',
    link: '/products/advantages'
  },
  {
    title: 'pages.products.service.title',
    content: '',
    image: '/images/AccordionSection.jpg',
    link: '/products/service'
  }
  
]);

</script>

<style scoped lang="scss">
// 子路由布局样式
.layout-container {
  display: flex;
  padding: 100px 40px 40px;
  max-width: 1400px;
  margin: 0 auto;
  gap: 40px;

  .sidebar {
    width: 280px;
    flex-shrink: 0;
  }

  .content {
    flex: 1;
    min-width: 0;
  }
}

// 主路由布局样式
.company-main-layout {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

@media screen and (max-width: 768px) {
  .layout-container {
    flex-direction: column;
    padding: 80px 20px 20px;
    gap: 20px;
    align-items: center;

    .sidebar {
      display: none;
    }

    .content {
      width: 100%;
      max-width: 800px;
      text-align: center;
    }
  }
}
</style> 
